import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/sections/Navbar";
import Breadcrumb from "../components/ui/Breadcrumb";
import PageHeader from "../components/sections/PageHeader";
import Button from "../components/ui/Button";
import { useAuth } from "../context/AuthContext";
import "./Dashboards.css";

export default function Dashboards() {
  const { authorizedFetch, user } = useAuth();
  const navigate = useNavigate();
  const [onderzoeken, setOnderzoeken] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadDashboards = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await authorizedFetch("/api/onderzoeken/");
      const payload = await response.json().catch(() => []);
      if (!response.ok) {
        throw new Error(payload?.detail || "Dashboards konden niet worden geladen.");
      }
      setOnderzoeken(Array.isArray(payload) ? payload : []);
    } catch (err) {
      setError(err.message || "Dashboards konden niet worden geladen.");
    } finally {
      setLoading(false);
    }
  }, [authorizedFetch]);

  useEffect(() => {
    loadDashboards();
  }, [loadDashboards]);

  return (
    <div>
      <Navbar />
      <main className="container dashboards-page">
        <Breadcrumb icon="home-line.png" items={[]} current="Dashboards" />
        <PageHeader title="Dashboards" />
        <p className="dashboards-page__intro">
          Selecteer een dashboard waarvoor jouw regio toegang heeft.
        </p>

        {error && <p className="dashboards-page__error">{error}</p>}
        {loading && <p>Dashboards laden…</p>}
        {!loading && !error && onderzoeken.length === 0 && (
          <div className="dashboards-page__empty">
            Er zijn momenteel geen dashboards beschikbaar voor jouw regio.
          </div>
        )}

        <div className="dashboards-page__grid">
          {onderzoeken.map((onderzoek) => (
            <article className="dashboards-page__card" key={onderzoek.id}>
              <div className="dashboards-page__icon" aria-hidden="true">
                <img src="/icons/monitor.png" alt="" />
              </div>
              <div className="dashboards-page__content">
                <h2>{onderzoek.name}</h2>
                <p>Bekijk de resultaten en rapportages van dit onderzoek.</p>
                {onderzoek.vragenlijsten?.length > 0 && (
                  <ul className="dashboards-page__questionnaires">
                    {onderzoek.vragenlijsten.map((vragenlijst) => (
                      <li key={vragenlijst.slug}>{vragenlijst.name}</li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="dashboards-page__actions">
                <Button onClick={() => navigate(onderzoek.dashboard_route)}>
                  Open dashboard
                </Button>
                {user?.role === "superadmin" && onderzoek.slug === "loon-op-zand" && (
                  <Button
                    variant="secondary"
                    onClick={() => navigate("/dashboards/loon-op-zand/tekstantwoorden")}
                  >
                    Tekstantwoorden bewerken
                  </Button>
                )}
              </div>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}
